import { Theme } from '@logto/schemas';
import type { TFuncKey } from 'i18next';
import { useContext } from 'react';

import StaticPageLayout from '@/Layout/StaticPageLayout';
import PageContext from '@/Providers/PageContextProvider/PageContext';
import EmptyStateDark from '@/assets/icons/empty-state-dark.svg?react';
import EmptyState from '@/assets/icons/empty-state.svg?react';
import DynamicT from '@/components/DynamicT';
import NavBar from '@/components/NavBar';
import PageMeta from '@/components/PageMeta';
import schoolModule from '@/assets/school_module.png';
import logo from '@/assets/logo.png';

import SupportInfo from './SupportInfo';
import styles from './index.module.scss';

type Props = {
  readonly title?: TFuncKey;
  readonly message?: TFuncKey;
  readonly rawMessage?: string;
};
const ErrorPage = ({ title = 'description.not_found', message, rawMessage }: Props) => {
  const { theme } = useContext(PageContext);
  const errorMessage = Boolean(rawMessage ?? message);
  // check domain is https://stage-sso.megasoft.edu.vn schoolApp = https://stage-school.megasoft.edu.vn, https://sso.megasoft.edu.vn https://school.megasoft.edu.vn else http://localhost:8081

  const currentSSODomain = window.location.origin;

  let schoolApp: string;

  if (currentSSODomain.includes('stage-sso.megasoft.edu.vn')) {
    schoolApp = 'https://stage-school.megasoft.edu.vn';
  } else if (currentSSODomain.includes('sso.megasoft.edu.vn')) {
    schoolApp = 'https://school.megasoft.edu.vn';
  } else {
    schoolApp = 'http://localhost:8081';
  }
  let adminApp: string;

  if (currentSSODomain.includes('stage-sso.megasoft.edu.vn')) {
    adminApp = 'https://stage-admin.megasoft.edu.vn';
  } else if (currentSSODomain.includes('sso.megasoft.edu.vn')) {
    adminApp = 'https://admin.megasoft.edu.vn';
  } else {
    adminApp = 'http://localhost:8082';
  }

  return (
    <StaticPageLayout>
      <PageMeta titleKey={title} />
      {history.length > 1 && <NavBar />}
      <div className={styles.container}>
        <img src={logo} alt="logo"/>
        <div className={styles.titleApp}> Đăng nhập hệ thống</div>
        <div className={styles.boxApp}>
          <a className={styles.cardApp} href={schoolApp}>
            <img src={schoolModule} alt=""/>
            <div>Quản lý trường học</div>
          </a>
          <a className={styles.cardApp} href={adminApp}>
            <img src={schoolModule} alt=""/>
            <div>Admin</div>
          </a>
        </div>
        {/*{theme === Theme.Light ? <EmptyState /> : <EmptyStateDark />}*/}
        {/*<div className={styles.title}>*/}
        {/*  <DynamicT forKey={title} />*/}
        {/*</div>*/}
        {/*{errorMessage && (*/}
        {/*  <div className={styles.message}>{rawMessage ?? <DynamicT forKey={message} />}</div>*/}
        {/*)}*/}
        <SupportInfo />
      </div>
    </StaticPageLayout>
  );
};

export default ErrorPage;
